import { render, staticRenderFns } from "./ChooseDepartItem.vue?vue&type=template&id=6715aa12&scoped=true&"
import script from "./ChooseDepartItem.vue?vue&type=script&lang=js&"
export * from "./ChooseDepartItem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDepartItem.vue?vue&type=style&index=0&id=6715aa12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715aa12",
  null
  
)

export default component.exports